
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserInterface, UserRepoInterface } from "@/services/Users/Interfaces";

@Component({
  inject: ['userRepository'],
})
export default class UserPicker extends Vue  {
  private userRepository!: UserRepoInterface;

  public userSearchLoading = false;

  public users: UserInterface[] = [];

  @Prop({ default: "", required: false, type: String}) public value!: string | null;

  private _userSearch = '';

  public get userSearch(): string {
    return this._userSearch;
  }

  public set userSearch(val: string) {
    this._userSearch = val;

    this.userSearchLoading = true;
    this.userRepository.getAllUsers(1, val).then((usersResponse) => {
      this.users = usersResponse[0];
      this.userSearchLoading = false;
    });
  }

  get userId(): string | null {
    return this.value;
  }

  set userId(value: string | null) {
    this.$emit('input', value);
  }
}
